var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35589 10.5037C7.71944 8.95458 8.33762 7.4832 9.10492 6.28795C10.275 4.46525 11.6064 3.54763 12.6989 3.54763C13.7664 3.54763 14.9873 4.43315 16.0552 6.2529C16.7708 7.4723 17.3372 8.98797 17.6724 10.5896L16.8812 11.3545L15.4465 9.96955L14.0739 9.97005L12.6428 11.3535L11.2142 9.97058L9.87057 9.94228L8.25992 11.3778L7.35589 10.5037ZM7.00909 12.9848C6.92219 15.1517 7.52334 16.5727 8.42069 17.4652C9.36584 18.4051 10.7862 18.9048 12.5283 18.9048C14.2708 18.9048 15.6837 18.4049 16.6176 17.4682C17.4899 16.5932 18.0748 15.2057 17.9935 13.0954L17.5682 13.5065L16.1956 13.507L14.7609 12.1221L13.3288 13.5065L11.9552 13.506L10.4994 12.0966L8.88917 13.5318L7.54594 13.504L7.00909 12.9848ZM12.6989 1.5C10.5775 1.5 8.72242 3.15562 7.43357 5.16332C6.10957 7.22577 5.18687 9.94127 5.02412 12.6357C4.85884 15.3716 5.58419 17.4989 7.02717 18.9339C8.45272 20.3516 10.4373 20.9524 12.5283 20.9524C14.6188 20.9524 16.6006 20.3518 18.0172 18.9308C19.4514 17.4923 20.1583 15.3621 19.9711 12.6273C19.789 9.9667 18.9818 7.26415 17.7696 5.19838C16.5897 3.18773 14.8455 1.5 12.6989 1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.839d4d0441cda900b3d13b913967f00e.svg";
export { ForwardRef as ReactComponent };